import React, { Component } from 'react'
import { Row, Button, Input, Spin, message, Checkbox } from 'antd';
import intl from "react-intl-universal";

import { store } from 'Store/store.index';
import { COLLECT_NPS_SURVEY } from 'Constants/app.constant';
import { USER_SIGN_IN_SUCCESS } from 'Store/constants';
import './NPSSurvey.scss';
const { TextArea } = Input;
const MAX_COUNT = 10;
const MAX_DAYS = 90;
const BEGIN_MONTH = 8;
const BEGIN_TIME = new Date(2021, BEGIN_MONTH - 1, 19).getTime();// 2021-07-19, when to start

const TOTAL_GROUP = [[1, 4, 7, 10], [2, 5, 8, 11], [3, 6, 9, 12]];

/**
 * https://confluence.foxitsoftware.com/pages/viewpage.action?pageId=121979239
 * https://confluence.foxitsoftware.com/pages/viewpage.action?pageId=119381385
 * ONLINERD-3825 ONLINERD-5747
 *  
 * //
 */

export default class NPSSurvey extends Component {
  constructor() {
    super()
    //createTime
    this.state = {
      loading: false,
      visible: false,
      firstOptions: Array(10).fill(0),
      fisrtVal: -1,
      secondVal: '',
      showThanks: false,
      isContact: true
    }
    this.userNPS={
      lastSubmitTime: null,
      count: 0,
      cancelCount: 0
    },
    this.onClose = this.onClose.bind(this);
    this.onResponseSurvey = this.onResponseSurvey.bind(this);
    this.requestNPSData = this.requestNPSData.bind(this);
    this.onClickFirstQuestion = this.onClickFirstQuestion.bind(this);
    this.onSubmitNPS = this.onSubmitNPS.bind(this);
  }
  componentDidMount() {
    store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, this.requestNPSData);
    store.appStore.addAppEventListener(COLLECT_NPS_SURVEY, this.onResponseSurvey);
    if (store.userStore.hasSignIn) {
      this.requestNPSData();
    }
  }
  componentWillUnmount() {
    store.appStore.removeAppEventListener(USER_SIGN_IN_SUCCESS, this.requestNPSData);
    store.appStore.removeAppEventListener(COLLECT_NPS_SURVEY, this.onResponseSurvey);
  }
  /**
    * @returns {[Number]} 1 - 12
   */
  getActiveMonthGroup(currentMonth) {
    let first, second, third;
    let activeGroup;
    TOTAL_GROUP.some((subGroup, index) => {
      if (subGroup.includes(BEGIN_MONTH)) {
        first = TOTAL_GROUP[index];
        second = TOTAL_GROUP[(index + 1) % 3]; second = [...first, ...second];
        third = TOTAL_GROUP[(index + 2) % 3];
        first.includes(currentMonth) && (activeGroup = first);
        !activeGroup && second.includes(currentMonth) && (activeGroup = second);
        !activeGroup && third.includes(currentMonth) && (activeGroup = third);
        return true;
      }
    })
    return activeGroup;
  }
  isInActiveGroup() {
    let now = new Date();
    let year = now.getFullYear();
    let currentMonth = now.getMonth() + 1;
    if (year >= 2021 && currentMonth >= 10) {
      return true;
    }
    let createTime = store.userStore.userInfo.createTime;
    if (!createTime) {
      createTime = Date.now();
    }

    if (createTime > BEGIN_TIME) {
      return true;
    }

    let date = new Date(createTime);
    let userCreatedMonth = date.getMonth() + 1;
    let activeGroup = this.getActiveMonthGroup(currentMonth);

    if (!activeGroup) {
      console.error('can not find activeGroup')
      return false
    }

    let isIn = activeGroup.includes(userCreatedMonth);
    return isIn;
  }
  onResponseSurvey() {
    //Date.now()
    if (!store.userStore.hasSignIn) {
      return;
    }
    const { lastSubmitTime, count, cancelCount } = this.userNPS;
    if (cancelCount >= 3) {
      return;
    }
    // calculate
    let newCount = 0;
    let countDay = 0;

    newCount = count + 1;
    if (newCount < MAX_COUNT) {
      // less than
      return this.updateNPSData(void 0, 1, 0);
    }

    if (!lastSubmitTime) {
      // newCount >= 30(MAX_COUNT), first pop-up
      return this.showSurveyDialog(true)
    }

    // 1 to 90
    const nowTime = Date.now();
    countDay = (nowTime - lastSubmitTime) / (1000 * 60 * 60 * 24) >>> 0;
    if (countDay < MAX_DAYS) {
      return;
    }
    return this.showSurveyDialog();
  }
  paserSurveyNPS(result) {
    if (result && result.ret === 0) {
      const { lastSubmitTime, count, cancelCount } = result.data;
      this.userNPS= {
          lastSubmitTime: lastSubmitTime ? parseInt(lastSubmitTime) : 0,
          count,
          cancelCount,
        }
    }
  }
  requestNPSData() {
    store.userStore.getSurveyNPS().then((result) => {
      this.paserSurveyNPS(result);
    })
  }
  updateNPSData(newSubmitTime, countIncrement, cancelCountIncrement) {
    return store.userStore.updateSurveyNPS({ lastSubmitTime: newSubmitTime, countIncrement, cancelCountIncrement }).then((result) => {
      this.paserSurveyNPS(result);
      return result;
    })
  }
  onClickFirstQuestion(val) {
    this.setState({
      fisrtVal: val
    })
  }
  onChangeSecondText = ({ target: { value } }) => {
    this.setState({ secondVal: value });
  };
  showSurveyDialog(isFirst) {
    if (isFirst && !this.isInActiveGroup()) {
      return;
    }
    this.setState({
      visible: true
    })
  }
  onClose() {
    this.setState({
      visible: false,
      fisrtVal: -1,
      secondVal: ""
    }, () => {
      store.userStore.doSendNPSData({ action: 'abort' })
      return this.updateNPSData(void 0, 0, 1);
    })
  }
  onSubmitNPS() {
    let lastSubmitTime = Date.now();
    this.setState({
      loading: true
    })
    this.updateNPSData(lastSubmitTime, 0, 0).then((result) => {
      if (result && result.ret === 0) {
        // TODO: send to dashboard
        const { fisrtVal, secondVal, isContact } = this.state;
        store.userStore.doSendNPSData({
          action: 'submit',
          extraInformation: {
            point: fisrtVal,
            answer: !secondVal ? "" : secondVal,
            contact: isContact ? 1 : 0
          }
        })

        this.setState({
          visible: false,
          fisrtVal: -1,
          secondVal: "",
          showThanks: true
        }, () => {
          let handle = setTimeout(() => {
            clearTimeout(handle);
            this.setState({
              showThanks: false
            })
          }, 5000);
        })
      } else {
        //message.error(intl.get('Error.Unknown'))
        throw result;
      }
    }).catch((err) => {
      message.error(intl.get('Error.Unknown'));
      throw err;
    }).finally(() => {
      this.setState({
        loading: false
      })
    });


  }
  render() {
    const { visible, firstOptions, fisrtVal, secondVal, showThanks, loading, isContact } = this.state;
    if (showThanks) {
      return (
        <div className="nps-survey nps-tks-content">
          <div className='m-a ta-c'>
            <Row className='mb-20' type='flex' justify='center'>
              <div className={'nps-thanks'} />
            </Row>
            <Row className='mb-10' justify='center'><span className='text-1'>{intl.get('Survey.NPS.thanks.content')}</span></Row>
            <Row justify='center'><span className='text-2'>{intl.get('Survey.NPS.thanks.SubContent')}</span></Row>
          </div>
        </div>
      )
    }
    if (!visible) {
      return null;
    }
    return (
      <div className="nps-survey">
        <Spin spinning={loading} size='large'>
          <div className='closeIcon c-p' onClick={this.onClose}><i ></i></div>
          <div className='m-a ta-c '>
            <Row className={'mb-22 c-444'}>
              {/* 'question-1' */}
              <Row>
                <Row className='question-info mb-20' type='flex' justify='center'>
                  <Row className='subject' ><span>{intl.get('Survey.NPS.subjects.1')}</span></Row>

                </Row>
                <Row className='mb-10' >
                  <Row type='flex' justify="space-between" className='option-faces mb-10'>
                    {
                      firstOptions.map((val, index) => {
                        return (
                          <div className={`option-face fv__icon-nps-face${index + 1} ${fisrtVal === (index + 1) ? 'selected' : ''}`} key={val + "-" + index} onClick={() => { this.onClickFirstQuestion(index + 1) }}>

                          </div>
                        )
                      })
                    }
                  </Row>
                  <Row type='flex' justify="space-between" className='option-texts'>
                    {
                      firstOptions.map((val, index) => {
                        return (
                          <div className={`text-wrapper ${fisrtVal === (index + 1) ? 'selected' : ''}`} key={val + "-" + index}>
                            <span>{index + 1}</span>
                          </div>
                        )
                      })
                    }
                  </Row>
                </Row>
                <Row className='c-999 fs-12 plpr-10 likely-content' type='flex' justify="space-between">
                  <span>{intl.get('Survey.NPS.NotLikely')}</span>
                  <span>{intl.get('Survey.NPS.VeryLikely')}</span>
                </Row>
              </Row>
              {/* 'question-2' */}
              {fisrtVal > -1 &&
                <Row className='mt-10 subjects2'>
                  <Row>
                    <TextArea
                      value={secondVal}
                      onChange={this.onChangeSecondText}
                      placeholder={intl.get('Survey.NPS.subjects.2')}
                      autoSize={false}
                    />
                  </Row>
                </Row>
              }
            </Row>
            {fisrtVal !== -1 &&
              <>
                <Row className={'c-999 ta-c checkbox-area'}>
                  <Checkbox disabled={fisrtVal === -1}
                            className='contact-checkbox'
                            checked={isContact}
                            onChange={e => this.setState({ isContact: e.target.checked })}
                  >
                    {intl.get('Survey.NPS.contactLabel')}
                  </Checkbox>
                </Row>
                <Row className={'c-999 ta-c summit-btn'}>
                  <Button disabled={fisrtVal === -1} className='online-solid-btn' onClick={this.onSubmitNPS}>{intl.get('Survey.NPS.Submit')}</Button>
                </Row>
              </>
            }
          </div>
        </Spin>
      </div>
    )
  }
}
